import { css } from '@linaria/core';
import { Drawer } from 'antd';

import HeaderNavigation from '../header-navigation';

const styles = {
  drawer: css`
    max-width: 100vw;
    .ant-drawer-body {
      overflow-y: auto;
    }
    @media (max-width: 767px) {
      .ant-drawer-content {
        height: 100svh;
      }
    }
  `,
};

interface MobileNavigationProps {
  open: boolean;
  onClose: () => void;
}

const MobileNavigation = ({ open, onClose }: MobileNavigationProps) => (
  <Drawer
    title="Menu NexoTCG"
    placement="left"
    open={open}
    onClose={onClose}
    rootClassName={styles.drawer}
  >
    <HeaderNavigation onNavigate={onClose} />
  </Drawer>
);

export default MobileNavigation;
